<template>
  <div>
    <nav-breadcrumb :menu="[{label: ' 银行流水使用明细表'}]"/>
    <div class="xzpadd10 bg-purple of">
      <data-table
        :table-data="tableData"
        :columns="columns"
        :page.sync="page"
        :pageSize.sync="pageSize"
        :filters.sync="filters"
        :actions="actions"
      />
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../filters/Status2CN";
  import {removeItem,xmlBuildQuery} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";
  export default {
    name: "BankStatementSummaryList",
    data(){
      return{
        columns:[
          {
            name: '序号',
            type: 'index'
          },
          {
            label: '网银交易日期',
            field: 'de__txDate',
            formatter: (r,c,v) => {
              return moment(v).format('YYYY-MM-DD')
            },
          },
          {
            label: '类型',
            field: 'dx__appliedUse' ,
            formatter: (r,c,v) => {
              return Status2CN(v)
            },
          },
          {
            label: '笔数',
            field: 'de__counts'
          },
          {
            label: '总金额',
            field: 'de__totalAmount',
            formatter: (r,c,v) => {
              return formatMoney(v)
            },
          },

          {
            label: '操作',
            opts:[
              {
                label: '查看',
                class: 'el-icon-view',
                clickHandler: (index, row)=> {
                  this.$router.push(
                    {
                      path: 'View',
                      query: {
                        appliedUse: row.dx__appliedUse,
                        txDate: row.de__txDate,
                        totalAmount: row.de__totalAmount
                      }
                    }
                  )
                }
              },
            ]
          }
        ],
        tableData: {
          count: 0,
          data: []
        },
        dealerTypeOptions:[],
        page: 1,
        pageSize: 20,
        actions: [
          {
            label: '导出银行收息明细表',
            clickHandler:()=>{
              let routeData = this.$router.resolve({
                path: '/ix/fang/financing/reporting/BankStatementUse.List?format=xlsx',
                query: Object.assign(
                  {
                    pageSize:0
                  },
                  {}, xmlBuildQuery(this.filters))
              });
              window.open(routeData.href.replace('#/', '/'), '_blank');
            }
          }
        ],
        filters: {
          labelWidth: '150px',
          form: {
              dx__appliedUse:'',
            de__txDate:[],
          },
          columns: [
            {
              label: '网银交易日期',
              component: 'date-range-picker',
              field: 'de__txDate',
              op: ['gteq', 'lteq'],
              dateFormat: ['yyyy-MM-dd 00:00:00','yyyy-MM-dd 23:59:59'],
              span: 12
            },
            {
              label: '类型',
              component: 'el-select',
              field: 'dx__appliedUse',
              options:[
                {
                  label:'还款',
                  value:'Repay',
                },
                {
                  label:'提前还款',
                  value:'Repay In Advance',
                },
                {
                  label:'其他业务',
                  value:'Other',
                }
              ],
              op: 'eq'
            },
          ],
          onSubmit:()=>{
            this.page = 1
            this.getData()
          }
        }
      }
    },
    mounted() {
      this.getData()
    },
    computed: {
      filterParams() {
        return {
          pageSize: this.pageSize,
          pageOffset: (this.page - 1) * this.pageSize,
          'xlist.sort.dataField': 'de.txDate',
          'xlist.sort.order': 'desc'
        }
      }
    },
    watch: {
      filterParams: function (newVal) {
        this.getData()
      }
    },
    methods: {
      getData: function () {
        xhr.getBankStatementSummaryList(
          Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
          res=> {
            try {
              this.tableData = res.data
            }catch(e){

            }
          })

      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/BankStatementSummaryList.vue